<template>
    <Dialog  v-if="visible" size="small">
        <template v-slot:title>
            無線機設定の割り当て
        </template>

        <template v-slot:body>
            <div style="height: 90%; margin: 4px 80px">
                <el-select style="width: 100%;"
                    v-model="selectedModel"
                   :placeholder="$t('message.action_ip_radio_select_model')"
                   @change="onModelSelect">
                    <el-option
                        v-for="item in modelList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>

                <el-tree style="overflow: auto; height: calc(100% - 40px)"
                     class="settings-tree"
                     :data="settingsToShow"
                     :props="treeProps"
                     node-key="id"
                     ref="settingsTree"
                     highlight-current
                     @node-click="onNodeClick"
                >
                </el-tree>
            </div>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" @click="handleCancelClick" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" :disabled="disableSave" @click="handleSaveClick" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>

</template>

<script>
import server from "@/components/ServerApi.js";
import constants from "@/components/constants.js";
import commonUtil from '@/components/commonutil.js';
import Dialog from '@/components/pc/common/Dialog.vue'

export default {
    components: {
        Dialog
    },

    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        modelName: {
            type: String,
            default: null,
        },
        originalSetting: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            // Element UI の el-tree 用 props
            treeProps: {
                label: 'displayName'
            },

            selectedModel: null,
            selectedSettingId: null,
            selectedSettingName: null,

            modelList: [],
            settingsToShow: [],
        }
    },

    computed: {
        disableSave() {
            if (this.selectedModel === null) {
                return true;
            }

            if (this.selectedSettingId === null) {
                return true;
            }

            return false;
        },
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.initialize()
                this.selectInitialModel()
            }
        }
    },

    created() {
        this.fetchModelList()
        this.initialize()
    },

    methods: {
        closeDialog() {
            this.$emit('update:visible', false)
        },

        initialize() {
            this.selectedModel = null;
            this.selectedSettingId = null;
            this.selectedSettingName = null;
            this.settingsToShow = [];
        },

        getInitialModel() {
            return this.modelName;
        },

        selectInitialModel() {
            if (this.modelList.length === 0) {
                return;
            }

            const initialModel = this.getInitialModel();
            if (initialModel != null && this.modelList.some((model) => model.value === initialModel)) {
                this.onModelSelect(initialModel);
                return;
            }

            this.onModelSelect(this.modelList[0].value);
        },

        onModelSelect(model) {
            this.selectedModel = model;
            this.selectedSettingId = null;
            this.selectedSettingName = null;
            this.fetchSettingList();
        },

        onNodeClick(nodeData) {
            this.selectedSettingId = nodeData.id;
            this.selectedSettingName = nodeData.displayName;
        },

        async fetchModelList() {
            let response
            try {
                response = await server.post('/getipradiomodellist')
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchModelList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.modelList = response.data.modelList.map(model => ({value:model, label:model}));
                    if (this.visible) {
                        this.selectInitialModel();
                    }
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "fetchModelList", response.data.status);
                    break;
            }
        },

        async fetchSettingList() {
            let response
            try {
                response = await server.post('/getipradiosettinglist', {model: this.selectedModel})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchSettingList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.settingsToShow = response.data.settings;
                    this.syncSelectedSetting();
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "fetchSettings", response.data.status);
                    break;
            }
        },

        syncSelectedSetting() {
            const originalSettingId = this.originalSetting?.id;
            const originalSettingModel = this.originalSetting?.model;
            if (originalSettingId == null || originalSettingModel !== this.selectedModel) {
                this.$nextTick(() => {
                    this.$refs.settingsTree?.setCurrentKey(null);
                });
                return;
            }

            const assignedSetting = this.settingsToShow.find((setting) => setting.id === originalSettingId);
            if (assignedSetting == null) {
                this.$nextTick(() => {
                    this.$refs.settingsTree?.setCurrentKey(null);
                });
                return;
            }

            this.selectedSettingId = assignedSetting.id;
            this.selectedSettingName = assignedSetting.displayName;
            this.$nextTick(() => {
                this.$refs.settingsTree?.setCurrentKey(assignedSetting.id);
            });
        },

        handleSaveClick() {
            this.$emit('save', this.selectedSettingId, this.selectedModel, this.selectedSettingName)
            this.closeDialog()
        },

        handleCancelClick() {
            this.closeDialog()
        }
    }
}
</script>

<style scoped>

:deep(.settings-tree .el-tree-node__expand-icon) {
    display: none !important;
}

</style>
